export const BleedingDisorderRelationshipOptions = [
    { value: "Self", label: "Self" },
    { value: "Care Taker of Patient", label: "Care Taker of Patient" },
    { value: "Family Member of Patient", label: "Family Member of Patient" }
];